import $ from 'jquery'

$(".dismiss").click(function () {
    $(this).hide();
});